import React, { useEffect, useState } from 'react';
import { InputSelect, Button } from '@wajeez-web/components/ui';
import { ReturnTranslatedText } from '@wajeez-web/core/localization';
import {
  TableFiltersProps,
  FilterColumn,
  SelectedColumnsFilters,
  DateAndNumberComparisonValues,
  StringComparisonValues,
  OtherComparisonValues,
  NumberComparisonValues,
} from './types';
import { useTranslation } from 'react-i18next';
import { getFilterComponent } from './tableHelperComponents/getFilterComponent';
import { seperator } from './tableHelperComponents/seperatorComponent';
const filterTableDefaultValues: any = {
  addFilter: { state: false, selected: { label: '', value: '' } },
  selectFilter: null,
  stateOfSelectFilter: {
    label: '',
    key: '',
    value: { label: '', value: '' } || '',
    type: 'select',
    operator: { label: '', value: '' },
  },
};

const TabeleFilters: React.FC<TableFiltersProps> = ({
  columns,
  selectedColumnsFilters,
  setSelectedColumnsFilters,
}) => {
  const [filtersColumns, setFiltersColumns] = useState<FilterColumn[]>([]);
  const [addFilter, setAddFilter] = useState({
    state: false,
    selected: { label: '', value: '' },
  });
  const [selectFilter, setSelectFilter] = useState<any>(null);
  const [applyFilter, setApplayFilter] = useState(true);
  const [stateOfSelectFilter, setStateOfSelectFilter] =
    useState<SelectedColumnsFilters>({
      label: '',
      key: '',
      value: '',
      type: 'select',
      operator: { label: '', value: '' },
    });

  const { t } = useTranslation();

  useEffect(() => {
    setFiltersColumns(
      columns
        .filter((item) => item.dataType !== 'Image')
        .map((item: any) => ({
          label: item.header,
          key: item.id,
          operators:
            item.dataType === 'DateTime'
              ? DateAndNumberComparisonValues.map((operator) => {
                  const { label, value } = operator;

                  return {
                    label: t(`selects.labels.${label}`),
                    value,
                  };
                })
              : item.dataType === 'Number'
              ? NumberComparisonValues.map((operator) => {
                  const { label, value } = operator;

                  return {
                    label: t(`selects.labels.${label}`),
                    value,
                  };
                })
              : item.dataType === 'String'
              ? StringComparisonValues.map((operator) => {
                  const { label, value } = operator;

                  return {
                    label: t(`selects.labels.${label}`),
                    value,
                  };
                })
              : OtherComparisonValues.map((operator) => {
                  const { label, value } = operator;

                  return {
                    label: t(`selects.labels.${label}`),
                    value,
                  };
                }),
          isPopular: false,
          isSelected: false,
          type: item.dataType,
          operator: { label: '', value: '' },
        }))
    );
  }, [columns]);

  const backTodefault = () => {
    setAddFilter(filterTableDefaultValues.addFilter);
    setStateOfSelectFilter(filterTableDefaultValues.stateOfSelectFilter);
  };
  const handleSelect =
    (parentName: string | number | null, type: string) =>
    (name: string, value: any) => {
      // TODO : fix betweeen operator

      if (name === 'addFilterSelctore') {
        setAddFilter({ ...addFilter, selected: value });
        const selected: any = filtersColumns.find(
          (element) => element.key === value.value
        );
        setSelectFilter(selected);
        setStateOfSelectFilter({
          ...stateOfSelectFilter,
          label: value.label,
          key: value.value,
          value: '',
          type: selected.type,
          operator: { label: '', value: '' },
        });
      } else if (parentName) {
        const selectedIndex: number = selectedColumnsFilters.findIndex(
          (element) => element.key === parentName
        );
        const cols: SelectedColumnsFilters[] = selectedColumnsFilters;
        selectedColumnsFilters[selectedIndex] = {
          ...selectedColumnsFilters[selectedIndex],
          // value : name === 'operator' ? value : selectedColumnsFilters[selectedIndex]?.value,
          [name]:
            type === 'Boolean'
              ? value.value
              : type === 'select'
              ? value
              : value.toString(),
        };
        setSelectedColumnsFilters(cols);
      } else {
        setStateOfSelectFilter({
          ...stateOfSelectFilter,
          [name]:
            type === 'Boolean'
              ? value.value
              : type === 'select'
              ? value
              : value.toString(),
        });
      }
    };

  useEffect(() => {
    if (
      stateOfSelectFilter.operator?.value &&
      typeof stateOfSelectFilter.value
    ) {
      setApplayFilter(false);
    }
  }, [stateOfSelectFilter]);

  const handleApplyFilter = (e: React.MouseEvent<HTMLButtonElement>) => {
    e.preventDefault();

    setSelectedColumnsFilters([...selectedColumnsFilters, stateOfSelectFilter]);
    setApplayFilter(true);

    backTodefault();
  };

  const clearFilter = (i?: number) => {
    if (i || i === 0) {
      setSelectedColumnsFilters(
        selectedColumnsFilters.filter((item, j) => j !== i)
      );
    } else {
      setSelectedColumnsFilters([]);
    }

    setApplayFilter(true);

    backTodefault();
  };

  return (
    <div className=" w-full  py-5 px-4  ">
      {(selectedColumnsFilters.length !== 0 || addFilter.state) && (
        <div className="w-full   h-slider-full-screen   scrollbar-thin scrollbar-thumb-gray-500  overflow-y-auto  first:mt-0 flex flex-col ">
          <div className="w-full first:mt-0 ">
            <div>
              {selectedColumnsFilters.length > 0 && (
                <div
                  onClick={() => clearFilter()}
                  className="text-primary text-xs cursor-pointer my-auto ms-1 justify-end flex mb-2 hover:text-primary-light"
                >
                  Clear All
                </div>
              )}
              {selectedColumnsFilters.map((item, i) => {
                item.operator.label = t(
                  `selects.labels.${item.operator.label}`,
                  item.operator.label || ''
                );

                return (
                  <React.Fragment key={item.label + i}>
                    {i !== 0 && seperator()}
                    <div className="p-2 bg-white border border-gray-100 rounded break-all transition-all duration-200flex flex-col w-full">
                      <div className="flex w-full justify-between">
                        <p className="font-sans m-0 text-sm text-gray-900 text-left font-semibold normal-case break-words max-w-full">
                          <label>{item.label}</label>
                        </p>
                        <button
                          onClick={() => clearFilter(i)}
                          type="button"
                          className="leading-normal inline-flex items-center font-normal spark-button-focus h-6 text-xs  bg-transparent border-0 text-gray-800 hover:text-gray-700 hover:bg-gray-25 active:bg-gray-25 rounded-md"
                        >
                          <svg
                            xmlns="http://www.w3.org/2000/svg"
                            width="15"
                            height="15"
                            fill="currentColor"
                            viewBox="0 0 24 24"
                            name="close-circle-fill"
                            color="text-gray-200 hover:text-gray-600"
                            className="text-gray-200 hover:text-gray-600 custom-color"
                          >
                            <path
                              fill=""
                              fillRule="evenodd"
                              d="M12 2C6.477 2 2 6.477 2 12s4.477 10 10 10 10-4.477 10-10S17.523 2 12 2zM8.293 8.293a1 1 0 011.414 0L12 10.586l2.293-2.293a1 1 0 111.414 1.414L13.414 12l2.293 2.293a1 1 0 01-1.414 1.414L12 13.414l-2.293 2.293a1 1 0 01-1.414-1.414L10.586 12 8.293 9.707a1 1 0 010-1.414z"
                              clipRule="evenodd"
                            ></path>
                          </svg>
                        </button>
                      </div>
                      <div className="w-full first:mt-0 mt-3 space-y-2">
                        <InputSelect
                          onChange={handleSelect(item.key, 'select')}
                          placeholder="Select Field"
                          options={
                            filtersColumns.find((ele) => ele.key === item.key)
                              ?.operators || []
                          }
                          name="operator"
                          value={item.operator || undefined}
                        />
                        {getFilterComponent(
                          item.key,
                          i,
                          handleSelect,
                          stateOfSelectFilter,
                          selectedColumnsFilters,
                          t,
                          item.type
                        )}
                      </div>
                    </div>
                  </React.Fragment>
                );
              })}
              {addFilter.state && (
                <>
                  {selectedColumnsFilters.length > 0 && seperator()}
                  <div className="p-2  bg-white border border-gray-100 rounded break-all transition-all duration-200 flex flex-col w-full">
                    <div className=" first:mt-0 flex w-full justify-between ">
                      <p className="font-sans m-0 text-sm text-gray-900 text-left font-semibold normal-case break-words max-w-full">
                        <label>
                          {addFilter.selected.label || (
                            <ReturnTranslatedText
                              text={`Slider.content.${'New Filter'}`}
                            />
                          )}
                        </label>
                      </p>
                      <button
                        onClick={() =>
                          setAddFilter({
                            state: false,
                            selected: {
                              label: '',
                              value: '',
                            },
                          })
                        }
                        type="button"
                        className="leading-normal inline-flex items-center font-normal spark-button-focus h-6 text-xs  bg-transparent border-0 text-gray-800 hover:text-gray-700 hover:bg-gray-25 active:bg-gray-25 rounded-md"
                      >
                        <svg
                          xmlns="http://www.w3.org/2000/svg"
                          width="15"
                          height="15"
                          fill="currentColor"
                          viewBox="0 0 24 24"
                          name="close-circle-fill"
                          color="text-gray-200 hover:text-gray-600"
                          className="text-gray-200 hover:text-gray-600 custom-color"
                        >
                          <path
                            fill=""
                            fillRule="evenodd"
                            d="M12 2C6.477 2 2 6.477 2 12s4.477 10 10 10 10-4.477 10-10S17.523 2 12 2zM8.293 8.293a1 1 0 011.414 0L12 10.586l2.293-2.293a1 1 0 111.414 1.414L13.414 12l2.293 2.293a1 1 0 01-1.414 1.414L12 13.414l-2.293 2.293a1 1 0 01-1.414-1.414L10.586 12 8.293 9.707a1 1 0 010-1.414z"
                            clipRule="evenodd"
                          ></path>
                        </svg>
                      </button>
                    </div>
                  </div>
                  <div className="w-full first:mt-0 mt-3 space-y-2">
                    {addFilter.selected.value ? (
                      <>
                        {/* <InputSelect onChange={handelSelect(addFilter.selected.value,'select')} placeholder='Select Field' options={selectFilter.values} name='addFilterSelctore' value={stateOfSelectFilter.value || undefined} /> */}
                        <InputSelect
                          onChange={handleSelect(null, 'select')}
                          placeholder="Select Field"
                          options={selectFilter.operators}
                          name="operator"
                          value={stateOfSelectFilter.operator || undefined}
                        />
                        {getFilterComponent(
                          null,
                          0,
                          handleSelect,
                          stateOfSelectFilter,
                          selectedColumnsFilters,
                          t,
                          undefined,
                          selectFilter
                        )}
                      </>
                    ) : (
                      <InputSelect
                        onChange={handleSelect(null, 'select')}
                        placeholder="Select Field"
                        options={filtersColumns.map((item) => ({
                          label: item.label,
                          value: item.key,
                        }))}
                        name="addFilterSelctore"
                        value={addFilter.selected || undefined}
                      />
                    )}
                  </div>
                </>
              )}
            </div>
          </div>
          {(addFilter.selected.value ||
            addFilter.state ||
            selectedColumnsFilters.length > 0) && (
            <div className="w-full first:mt-0 mt-6 flex  justify-between">
              <button
                onClick={() => setAddFilter({ ...addFilter, state: true })}
                type="button"
                className="leading-normal inline-flex items-center font-normal spark-button-focus h-8 text-sm px-4 bg-transparent border-0 border-solid text-primary hover:text-primary-light active:text-primary rounded-md"
                aria-disabled="false"
              >
                <ReturnTranslatedText text={`buttons.${'Add Filter'}`} />
              </button>
              <Button
                onClick={handleApplyFilter.bind(this)}
                shape="squre"
                title={'Apply'}
                bg="primary"
                color="white"
                disabled={applyFilter}
              ></Button>
            </div>
          )}
        </div>
      )}
      {selectedColumnsFilters.length === 0 && !addFilter.state && (
        <div className="h-slider-full-screen ">
          <div className="w-full mt-5">
            <span className=" m-0 text-sm text-gray-600 text-left font-normal normal-case break-words max-w-full">
              <ReturnTranslatedText
                text={`Slider.content.${'No filters applied'}`}
              />
              .
            </span>
          </div>
          <div className="w-full first:mt-0 mt-5">
            <button
              onClick={() => setAddFilter({ ...addFilter, state: true })}
              type="button"
              className="leading-normal inline-flex items-center font-normal spark-button-focus h-8 text-md px-4 bg-primary border-0 text-white hover:text-white hover:bg-primary-light active:bg-primary focus:text-white rounded-md w-full justify-center"
            >
              <div className="flex items-center overflow-hidden">
                <span className="me-0 md:me-3">
                  <svg
                    xmlns="http://www.w3.org/2000/svg"
                    width="18"
                    height="18"
                    fill="currentColor"
                    viewBox="0 0 24 24"
                    name="add"
                    className=""
                  >
                    <path
                      fill=""
                      d="M13 4a1 1 0 10-2 0v7H4a1 1 0 100 2h7v7a1 1 0 102 0v-7h7a1 1 0 100-2h-7V4z"
                    ></path>
                  </svg>
                </span>
                <span className="w-0 invisible md:w-auto md:visible">
                  <ReturnTranslatedText
                    text={`Slider.content.${'Add Filter'}`}
                  />
                </span>
              </div>
            </button>
          </div>
        </div>
      )}
    </div>
  );
};

export default TabeleFilters;
